import React from 'react'
import { Create, SimpleForm, TextInput } from 'react-admin'

const UserCreate = props => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="email" />
      <TextInput source="password" type="password" />
      <TextInput source="age" />
      <TextInput source="pgy" />
      <TextInput source="cardsPerDay" />
      <TextInput source="onboardingStatus" />
    </SimpleForm>
  </Create>
)

export default UserCreate
